"use client";

import React, { useState } from 'react';
import styles from './DownloadResumeButton.module.css';
import Icon from './Icon';

export default function DownloadResumeButton() {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleDownload = async () => {
    setIsGenerating(true);
    
    try {
      const response = await fetch('/api/generate-resume', {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to generate resume');
      }

      // Get the blob from the response
      const blob = await response.blob();
      
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Bemoi-George-Resume-${new Date().getFullYear()}.pdf`;
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading resume:', error);
      alert('Failed to generate resume. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button 
      className={styles.downloadButton}
      onClick={handleDownload}
      disabled={isGenerating}
    >
      {isGenerating ? (
        <>
          <span className={styles.spinner}></span>
          Preparing PDF…
        </>
      ) : (
        <>
          <Icon name="download" size={18} strokeWidth={1.75} />
          Download Resume
        </>
      )}
    </button>
  );
}
